module.exports = __webpack_public_path__ + "img/adopisoft-logo-white.876208f6.png";